/**
 *Created by jmmartinez on 3/8/18
 * v.1.1  26/03/2019 Añadida propiedad status.
 * v.1.2  28/03/2019 Añadido método doDelete y comentado this.state en el catch
 * v.1.3  24/04/2019 Añadido abir ventana con pdf
 *                   Añadido descargar los xlsx
 * v.1.4  06/05/2019 Añadido callbackError en doGet, doPost, doDelete y procesar.
 * v.1.5  20/11/2019 Añadida numTotalElements.
 * v.1.6  24/04/2020 Añadida funcion window para los content-type: jpg y png
 * v.2.0  30/09/2020 Cambiado a framework2
 * v.2.1  05/04/2021 En el fetch de procesar se ha incluido el mime-type de los archivos .ods
 * v.2.2  05/04/2022 En el fetch de procesar se ha incluido el mime-type de los archivos .txt
 * v.2.3  30/01/2024 Añadido el método doPostPausa.
 * v.2.4  10/06/2024 En el método procesar, la rama Fetch, en el if (response.status === 200) añadido el tipo (contentType.toLowerCase().includes( "application/zip")
 *                   Añadido en el mismo sitio llamada al callback.
 * v.2.5  20/06/2024 En el método procesar, la rama Fetch, en el if. añadido if (response.status === 401) para lannzar el callbackError.
 * v.2.6  19/01/2026 Creados los métodos doGetBloqueante y doPostBloqueante
 **/

import {refreshSession} from "../utils/SessionUtils";
import {getFormattedDateTimeAhoraForFile} from "../utils/DateUtils"

class ClienteRestful {

    constructor(url) {
        this.token = '';
        this.resultado = {};
        this.exito = false;
        this.esjson = false;
        this.errores = '';
        this.url = url;
        this.timeout = 3000;
        this.status= 0;
        this.fileName= null;
        this.numTotalElements= 0;
    }

    setUrl(url) {
        this.url = url;
        return this;
    }

    setToken(token) {
        this.token = token;
        return this;
    }

    getResultado() {
        return this.resultado;
    }

    getErrores() {
        return this.errores;
    }



    isExito() {
        return this.exito;
    }

    getStatus() {
        return this.status;
    }

    getNumTotalElements() {
        return this.numTotalElements;
    }

    doGet(callback, callbackError) {
        this.procesar("GET", null, callback, callbackError);
    }

    doPost(entity, callback, callbackError) {
        this.procesar("POST", entity, callback, callbackError);
    }
    doPostPausa(pausams, entity, callback, callbackError){
        setTimeout(() =>{
            this.procesar("POST", entity, callback, callbackError);
            }, pausams);
    }

    async doGetBloqueante() {
        return new Promise((resolve, reject) => {
            this.procesar(
                "GET",
                null,
                (resultado) => resolve(resultado),
                (error) => reject(error)
            );
        });
    }

    async doPostBloqueante(entity) {
        return new Promise((resolve, reject) => {
            this.procesar(
                "POST",
                entity,
                (resultado) => resolve(resultado),
                (error) => reject(error)
            );
        });
    }

    doPut(entity, callback, callbackError) {
        this.procesar("PUT", entity, callback, callbackError);
    }

    doDelete(callback, callbackError) {
        this.procesar("DELETE", null, callback, callbackError);
    }

    //exposedHeaders: ['numele'],

    procesar(metodo, body, callback, callbackError){

        refreshSession();

        let headers = new Headers({
            'Accept': 'text/plain, application/json, application/pdf, application/vnd.ms-excel, application/octet-stream, application/zip, image/svg+xml, application/xlsx',
            'Content-Type': 'application/json'

        });



        if (this.token !== '') {
            headers.set("token", this.token);
        }

        let request = {
            method: metodo,
            headers: headers,
            //mode: 'no-cors',
        }

        if (metodo !== "GET" && body !== undefined) {
            request['body'] = JSON.stringify(body);
        }

        fetch(this.url, request)
            .then( response => {

                console.log("---------- FETCH --------------");
                console.log("url: ", this.url);
                console.log(response);
                var today = new Date();
                var now = today.toLocaleString();
                //console.log(now);


                if (response) {
                    this.status = response.status;
                }
                if (response.status === 200) {
                    //console.log("STATUS 200");
                    this.exito= true;
                    this.numTotalElements= response.headers.get('num-total-elements');
                    const contentType = response.headers.get('Content-type');
                    console.log("contentType.toLowerCase(): ", contentType.toLowerCase());
                    if (contentType && (contentType.toLowerCase().includes("application/json"))) {
                        this.esjson= true;
                        return response.json();
                    } else{
                        if (contentType && (contentType.toLowerCase().includes( "image/svg+xml"))) {
                            response.text().then((text) => {
                                callback && callback(text);
                            })
                        }
                        else {
                            if (contentType &&
                                (
                                 //contentType.toLowerCase().includes( "application/vnd.oasis.opendocument.spreadsheet")
                                 //||
                                 contentType.toLowerCase().includes( "application/pdf")
                                 ||
                                 contentType.toLowerCase().includes( "image/jpg")
                                 ||
                                 contentType.toLowerCase().includes( "image/png")
                                 ||
                                 contentType.toLowerCase().includes( "text/plain")
                                )) {
                                response.blob().then( (blob) => {
                                    console.log(blob);
                                    var objectURL = URL.createObjectURL(blob);
                                    console.log("objectURL: ", objectURL);
                                    window.open(objectURL);
                                })
                            }
                            else{
                                if (contentType && (
                                        (contentType.toLowerCase().includes( "application/xlsx"))
                                        ||
                                        (contentType.toLowerCase().includes( "application/vnd.oasis.opendocument.spreadsheet"))
                                        ||
                                        (contentType.toLowerCase().includes( "application/zip"))
                                        )
                                ) {
                                    response.blob().then( (blob) => {
                                        let  downloadedFileName=  getFileNameFromContentDisposition (response.headers.get('Content-Disposition'));
                                        //console.log(blob);
                                        let newFileName= this.fileName ? this.fileName : downloadedFileName ?  downloadedFileName : createFileName("xlsx");
                                        downloadBlob(blob, newFileName);
                                        callback && callback(response);
                                    })
                                }
                                else {
                                    this.esjson = false;
                                    callback && callback(response)
                                }
                            }
                        }
                    }
                }else {
                    if (response.status === 401) {
                        console.log("ERROR AUTH");
                        response.text().then(body => {
                            this.errores = body;
                            callbackError && callbackError(body);
                        }).catch(error => {
                            this.errores = "ERROR INDETERMINADO EN AUTH";
                        });
                    }
                    else {
                        console.log("ERROR");
                        console.log(response);
                        response.text().then(body => {
                            this.errores = body;
                            callback && callback(body);
                        }).catch(error => {
                            this.errores = "ERROR INDETERMINADO";
                        });
                    }
                }
            })
            .then( json  => {
                if (this.exito && this.esjson) {
                    console.log(">> callback: ", callback);
                    callback && callback(json);
                }
            })
            .catch(function(err) {
                //this.status= 0; <--- aqui no existe this 8(
                console.log("ERROR");
                console.log("err: ", err);
                //if (err)
                //    console.log("Error: ", err);
                callbackError && callbackError();
            });

    }

}

function downloadBlob(blob, fileName) {
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

function createFileName(extension) {
    let ahoraCadena= getFormattedDateTimeAhoraForFile();
    return ahoraCadena + "." + extension;

}

function getFileNameFromContentDisposition(contentDisposition){
    //console.log("getFileNameFromContentDisposition: ");
    //console.log(contentDisposition);

    //ejempor de contentDisposition --> attachment; filename="Cronologia Batman.ods"
    let posComillaInicial= contentDisposition.indexOf("\"");
    let fileName= contentDisposition.slice(posComillaInicial, -1); //-1 para no incluir la comilla final
    return fileName;
}

export default ClienteRestful;